/*
  Brandkit (pakket B), 14 okt 2026: voortgangsbalk "gratis verzending in Nederland" in de winkelwagenlade.
  Eigen bestand; global.js, cart.js en cart-drawer.js zijn niet gewijzigd.

  Dawn vervangt de HTML van de lade na elke wagenwijziging. Dit custom element onthoudt daarom de vorige stand
  (sessionStorage, met een terugval in het geheugen) en animeert bij elke nieuwe render van oud naar nieuw:
  - breedte via transform: scaleX(), 600 ms cubic-bezier(.22,1,.36,1);
  - bij groei één keer een glans over de balk;
  - bij het bereiken van de drempel een korte pulse;
  - de tekst faadt in.
  prefers-reduced-motion: direct naar de nieuwe stand, zonder glans of pulse.
*/
(function () {
  if (customElements.get('aa-cart-progress')) return;

  const KEY = 'aa-cart-progress';
  let memory = null;

  const read = () => {
    try {
      const value = window.sessionStorage.getItem(KEY);
      return value === null ? memory : parseFloat(value);
    } catch (error) {
      return memory;
    }
  };

  const write = (ratio) => {
    memory = ratio;
    try {
      window.sessionStorage.setItem(KEY, String(ratio));
    } catch (error) {
      /* opslag geblokkeerd: geheugen volstaat binnen deze pagina */
    }
  };

  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  customElements.define(
    'aa-cart-progress',
    class AaCartProgress extends HTMLElement {
      connectedCallback() {
        const fill = this.querySelector('.aa-progress__fill');
        if (!fill) return;

        const next = Math.max(0, Math.min(1, parseFloat(this.dataset.ratio) || 0));
        const stored = read();
        const previous = stored === null || Number.isNaN(stored) ? next : Math.max(0, Math.min(1, stored));
        write(next);

        if (reducedMotion() || previous === next) {
          fill.style.transform = `scaleX(${next})`;
          return;
        }

        // Vanaf de vorige stand beginnen, zonder overgang, en dan naar de nieuwe stand
        fill.classList.add('is-instant');
        fill.style.transform = `scaleX(${previous})`;
        fill.getBoundingClientRect();
        fill.classList.remove('is-instant');

        requestAnimationFrame(() => {
          fill.style.transform = `scaleX(${next})`;
          this.classList.add('is-updating');
          if (next > previous) this.classList.add('is-growing');
          if (next >= 1 && previous < 1) this.classList.add('is-celebrating');
        });

        fill.addEventListener(
          'transitionend',
          () => {
            this.classList.remove('is-growing', 'is-updating');
          },
          { once: true }
        );
        setTimeout(() => this.classList.remove('is-celebrating'), 900);
      }
    }
  );
})();
